import React from "react";
import Link from "gatsby-link";
import Helmet from "react-helmet";
import PropTypes from 'prop-types';
import Buynow from "../components/Buynow";
import CategoryDropdown from "../components/CategoryDropdown";

export default function Index({ data, pathContext }) {

	const { edges: posts } = data.allEJitem;
	const { edges: categories } = data.allEJcategory;

	return (
	  <div>
	  	<div className="hero home">
	  		<div className="hero-copy">
		    	<h1>Falken's Party Supplies</h1>
		    	<p>Why throw a standard party when you can make it an awesome party? Falken offers a variety of customization options for all your child's interests. If you have an idea for special cookies, cakes, party bags, or stickers, we have a solution for you. If you don't see it listed here, just contact us. We will build it to suit your special occasion.</p>
		    </div>
	    </div>
	    <section className="home-products">
		    <div className="container">
		    	<div className="filter-options">
			        <div className="searchbox">
			        	<form id="searchbox" action="" method="GET"><input type="text" name="search" id="search" placeholder="Search" /><input type="submit" value="Search" /></form>
			        </div>
		    		<CategoryDropdown categories={categories} current="All" />
		    	</div>
		      <div className="ej-shop-index">   
		      {posts
		        .filter(post => post.node.name.length > 0)
		        .map(({ node: post }) => {
		          return (
		            <div className="ej-item" key={post.id}>
		             	<img src={post.image} alt={post.name} />
		             	<div className="product-blurb">
			              <h2>
			                {post.name}
			              </h2>
			              <p>{post.description}</p>
			              <p>${post.price}</p>
			              <div className="item-tags">{post.tags}</div>
			              <Buynow  post={post} />
			          	</div>
		            </div>
		          );
		        })}
		      </div>
		    </div>
	    </section>
	    <section id="recipe-row" className="dark-row">
	    	<div className="container">
		    	<h2>Make sure you have the right dough for the job!</h2>
		    	<p>
		    		If you bought some dough and think you're ready to make some fancy detailed cookies you may want to consider another trip to the grocery store. Don't make the mistake of being unprepared. Review our non-stick cookie dough recipe and our helpful hints to make sure you're not stuck last minute.
		    	</p>
		    </div>
	    </section>
	  </div>
	);
}

export const pageQuery = graphql`
  query EJQuery {
	  allEJitem {
	    edges {
	      node {
	        id
	        currency
	        description
	        details
	        image
	        name
	        number
	        needs_advance_options
	        option1
	        option1_options
	        option2
	        option2_options
	        option3
	        option3_options
	        price
	        thumbnail
	        tagline
	        download_link
	        homepage_link
	        needs_options
	        on0
	        on0_options
	        on1
	        on1_options
	        on2
	        on2_options
	        purchased
	        tags
	        item_expiry
	        aff_perc
	        variable_pricing
	        file_size
	        source_country
	        needs_download
	        needs_keygen
	        product_extension
	        needs_exhaust_password
	        needs_multiple
	        sub_items{
	        	option1_value
	        	option2_value
	        	option3_value
	        	price
	    	}
	        ej_shop_id
	      }
	    }
	  },
	  allEJcategory( sort: {fields: [name], order: ASC}) {
    	edges {
	      node {
	        id
	        name
	        root
	        path
	      }
	    }
  	  }
  }
`;


// WEBPACK FOOTER //
// ./src/pages/index.js